// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1a1g0","label":"styles_label__13Ldd"};